<sc-loading-spinner>
  <div class="documents-list">
    @for (dp of documentPreviews; track dp) {
      <app-transport-document-item [preview]="dp" (click)="listItemClick(dp)">
      </app-transport-document-item>
    }
  </div>
</sc-loading-spinner>